var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0714 13.143L13.4146 18.7998C12.6335 19.5809 11.3672 19.5809 10.5862 18.7998L4.92931 13.143C2.97669 11.1903 2.97669 8.02451 4.92931 6.07189C6.88193 4.11927 10.0478 4.11927 12.0004 6.07189C13.953 4.11927 17.1188 4.11927 19.0714 6.07189C21.0241 8.02451 21.0241 11.1903 19.0714 13.143Z",
    stroke: "#726C6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHeart);
export default __webpack_public_path__ + "static/media/dashboardHeart.662951b6b9c8232a02aefd8478fcc05f.svg";
export { ForwardRef as ReactComponent };